// GAVION sequence-performance: the address class of an enrolment (generic shared mailbox, free webmail or a person's
// address). TS twin of public.email_is_generic / public.email_address_kind
// (supabase/schemas/103_gavion_sequence_performance.sql); the two lists are pinned to the SQL by opsParity.
// No imports: scripts/gavion/opsParity.test.ts reads this file outside the app's aliases.

/** Local parts of a shared mailbox (« info@ », « soumission@ »…), compared after lower-case, trim and any « +tag ». */
export const GENERIC_LOCAL_PARTS = [
  "info",
  "contact",
  "admin",
  "bureau",
  "service",
  "services",
  "ventes",
  "sales",
  "reception",
  "support",
  "office",
  "hello",
  "bonjour",
  "estimation",
  "soumission",
  "comptabilite",
  "facturation",
  "rh",
  "emploi",
  "jobs",
  "nous",
  "general",
  "web",
  "mail",
] as const;

/** Free webmail domains (checked before the local part: info@gmail.com is webmail). */
export const WEBMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "hotmail.com",
  "hotmail.ca",
  "hotmail.fr",
  "outlook.com",
  "outlook.fr",
  "live.com",
  "live.ca",
  "msn.com",
  "yahoo.com",
  "yahoo.ca",
  "yahoo.fr",
  "ymail.com",
  "videotron.ca",
  "videotron.qc.ca",
  "sympatico.ca",
  "bell.net",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "rogers.com",
  "cogeco.ca",
  "globetrotter.net",
  "telus.net",
  "shaw.ca",
  "protonmail.com",
  "proton.me",
] as const;

export const ADDRESS_KINDS = ["nominative", "generic", "webmail"] as const;
export type AddressKind = (typeof ADDRESS_KINDS)[number];

const parts = (email: string | null | undefined): [string, string] => {
  const s = (email ?? "").trim().toLowerCase();
  const at = s.indexOf("@");
  // split_part(s, '@', 2): the text between the first and the second « @ »
  if (at < 0) return [s, ""];
  const rest = s.slice(at + 1);
  const second = rest.indexOf("@");
  return [s.slice(0, at), second < 0 ? rest : rest.slice(0, second)];
};

export function emailIsGeneric(email: string | null | undefined): boolean {
  const local = parts(email)[0].replace(/\+.*$/, "");
  return (GENERIC_LOCAL_PARTS as readonly string[]).includes(local);
}

export function emailAddressKind(
  email: string | null | undefined,
): AddressKind {
  if ((WEBMAIL_DOMAINS as readonly string[]).includes(parts(email)[1]))
    return "webmail";
  return emailIsGeneric(email) ? "generic" : "nominative";
}
